import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { reportingApiEvents } from 'modules/api/reporting'
import { apiStateSelectors } from 'modules/api/apiState'
import { Button } from 'views/components'
import styles from './DownloadCreditNotePdfButton.module.scss'

type Props = {
  invoiceId: string
  invoiceNumber: string
}

const DownloadCreditNotePdfButton = ({ invoiceId, invoiceNumber }: Props) => {
  const dispatch = useDispatch()
  const handleDownload = useCallback(() => {
    dispatch(reportingApiEvents.downloadCreditNotePdf_request({ invoiceId, invoiceNumber }))
  }, [invoiceId, dispatch])

  const isLoading = useSelector(state =>
    apiStateSelectors.isLoading(state)([reportingApiEvents.downloadCreditNotePdf_request]),
  )

  return (
    <Button loading={isLoading} ghost className={styles.root} onClick={handleDownload}>
      Download credit note
    </Button>
  )
}

export default DownloadCreditNotePdfButton
